import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import styled from "@emotion/styled";
import { storeOperations, storeSelector } from "state/ducks/store";
import { getForecastingPdfMessage } from "state/ducks/store/operations";

const PdfMessengerButton = props => {
  const { establishmentId, types, categoriesFilter } = props;

  const [loadPdf, setLoadPdf] = useState(false);
  // utile pour calculer les dates
  const [weekPrinted, setWeekPrinted] = useState(0);

  // Cherche les stocks et le détail de l'établissement
  const forecastStocks = useSelector(state => {
    return storeSelector.getForecastStocksPrintSelector(state);
  });
  const establishment = useSelector(state => state.session.establishment);

  const dispatch = useDispatch();

  /**
   * Lance la requete pour télécharger le PDF des stocks prévisionnels
   */
  const generatePdf = async week => {
    setWeekPrinted(week);
    let categoriesTransform = [];
    if (categoriesFilter) {
      categoriesFilter.forEach((category, key) => {
        categoriesTransform = [...categoriesTransform, category.value];
      });
    }

    setLoadPdf(true);
    
    try {
      // Construire l'URL avec les paramètres
      const baseUrl = process.env.REACT_APP_LEMOULIN_API_URL || '';
      let url = `${baseUrl}/v2/store/product/stock/forecasting/pdf/message?establishment=${establishmentId}&week=${week}`;
      
      // Ajouter les types d'activité
      if (types && types.length > 0) {
        types.forEach(type => {
          url += `&types[]=${type}`;
        });
      }
      
      // Ajouter les catégories
      if (categoriesTransform && categoriesTransform.length > 0) {
        categoriesTransform.forEach(category => {
          url += `&categories[]=${category}`;
        });
      }

      const response = dispatch(getForecastingPdfMessage(establishmentId, week, types, categoriesTransform)).then(response => {
        if (response?.data?.result?.message) {
          alert(response?.data?.result?.message);
          if (response?.data?.result?.url) {
            window.open(response?.data?.result?.url, '_blank');
          }
        }
        else {
          alert('Une erreur est survenue lors de la génération du PDF');
        }
      });
    } catch (error) {
      console.log(error);
      console.error('Erreur lors de la génération du PDF:', error);
      alert('Une erreur est survenue lors de la génération du PDF');
    } finally {
      setLoadPdf(false);
    }
  };

  return (
    <div>
      {!loadPdf ? (
        <>
          <Item onClick={() => generatePdf(-1)}>Semaine - 1</Item>
          <Item onClick={() => generatePdf(0)}>Semaine en cours</Item>
          <Item onClick={() => generatePdf(1)}>Semaine + 1</Item>
          <Item onClick={() => generatePdf(2)}>Semaine + 2</Item>
        </>
      ) : (
        "Géneration du pdf en cours..."
      )}
    </div>
  );
};

const Item = styled(Dropdown.Item)`
  border-bottom: solid 1px #ccc;
  &:hover {
    background-color: #ddd;
  }
`;

PdfMessengerButton.propTypes = {
  establishmentId: PropTypes.string, // Id de l'établissent
  types: PropTypes.array, // Liste des types d'activité pour les stocks
  categoriesFilter: PropTypes.array // La valeur du filtre catégorie
};

export default PdfMessengerButton;
